import { Injectable } from '@angular/core';
import { IPKImportLog, IPKUserMatch } from '@fi-app/external-platform-integration/pk/pk';
import { PKUsersImportType } from '@fi-app/external-platform-integration/pk/pk-users-import-type';

@Injectable()
export class PkHelperService {
    constructor() {}

    getUserContactValue(user: IPKUserMatch, pkUsersImportType: PKUsersImportType) {
        if (pkUsersImportType === PKUsersImportType.ByEmail) return user.Email;
        if (pkUsersImportType === PKUsersImportType.ByPhoneNumber) return user.PhoneNumber;
        throw new Error(`getUserContactValue: unknown import type ${pkUsersImportType}`);
    }

    getUserUnitNamesText(user: IPKUserMatch) {
        return user.UnitNames.join(', ');
    }
    getUserRoleNamesText(user: IPKUserMatch) {
        return user.RoleNames.join(', ');
    }

    hasErrors(log: IPKImportLog) {
        return !!log.ErrorMessage;
    }
}
